var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { useStyles } from './Field.styles';
import InputBase from '@mui/material/InputBase';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
export const Field = (props) => {
    const classes = useStyles();
    const { isDisabled, label, helperText, errorText } = props, rest = __rest(props, ["isDisabled", "label", "helperText", "errorText"]);
    const [isFocused, setIsFocused] = useState(false);
    return (React.createElement(FormControl, { error: props.error, className: `${(!helperText && !errorText) || (isFocused && errorText) ? classes.standard : ''} ${rest.error && !isFocused ? classes.error : ''}`, sx: classes.formControl },
        React.createElement(Typography, { sx: classes.label, component: "label", variant: "h6" },
            props.label,
            props.required && '*'),
        React.createElement(InputBase, Object.assign({}, rest, { disabled: isDisabled, onFocus: () => setIsFocused(true), onBlur: () => setIsFocused(false) })),
        helperText && !errorText && (React.createElement(Typography, { sx: classes.helpLabel, variant: "caption" }, helperText)),
        errorText && !isFocused && (React.createElement(Typography, { color: "error", sx: classes.helpLabel, variant: "caption" }, errorText))));
};
export default Field;
